import { render, staticRenderFns } from "./WorkshopEvaluations.vue?vue&type=template&id=b44c483e"
import script from "./WorkshopEvaluations.vue?vue&type=script&lang=ts"
export * from "./WorkshopEvaluations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports